import style from './style.scss';

/**
 * Displays a small date label in the top right portion of a card.
 * NOTE: needs to be inside a container with relative positioning.
 *
 * props:
 * - date: formatted date string to be displayed
 */
const CardDateLabel = props => (
	<span class={style.date_label}>
		{ props.date }
	</span>
);

export default CardDateLabel;



// WEBPACK FOOTER //
// ./components/card-date-label/index.js